var _defs, _rect, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlleviMarkRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 431.02 70.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#da3835;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AlleviMarkRed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 423.61,
    y: 12.28,
    width: 7.41,
    height: 43.66
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "262.69 49.24 262.69 56.66 232.79 56.66 232.79 13 240.2 13 240.2 49.24 262.69 49.24"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "202.46 49.24 202.46 56.66 172.53 56.66 172.53 13 179.95 13 179.95 49.24 202.46 49.24"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "303.23 19.69 303.23 30.4 324.48 30.4 324.48 37.81 303.23 37.81 303.23 48.52 327.46 48.52 327.46 55.94 295.81 55.94 295.81 12.28 327.46 12.28 327.46 19.69 303.23 19.69"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "142.2 56.1 134.13 56.1 119.59 21.79 105.03 56.1 96.96 56.1 97.11 55.77 115.64 12.12 123.53 12.12 142.2 56.1"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "352.53 12.12 360.61 12.12 375.14 46.42 389.7 12.12 397.77 12.12 397.63 12.44 379.1 56.1 371.21 56.1 352.53 12.12"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "33.94 70.05 26.4 65.7 26.4 56.99 33.94 52.64 41.48 56.99 41.48 65.7 33.94 70.05"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "62.62 33.2 58.15 33.2 58.15 46.03 45.82 53.27 48.23 57.02 62.62 48.53 62.62 33.2"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5.24 33.2 9.71 33.2 9.71 46.03 22.04 53.27 19.63 57.02 5.24 48.53 5.24 33.2"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.12 24.22 19.52 27.98 31.77 35.84 31.77 47.09 36.06 47.09 36.06 35.84 48.4 27.98 45.8 24.22 33.92 31.91 22.12 24.22"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "60.38 27.76 52.84 23.4 52.84 14.7 60.38 10.35 67.92 14.7 67.92 23.4 60.38 27.76"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.05 8.58 20.11 12.42 33.97 5.09 47.81 12.42 49.87 8.76 33.97 0 18.05 8.58"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "7.54 27.76 0 23.4 0 14.7 7.54 10.35 15.08 14.7 15.08 23.4 7.54 27.76"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlleviMarkRed);
export default __webpack_public_path__ + "static/media/AlleviMarkRed.25c804c3205e43eaa54a00b6f3ea1409.svg";
export { ForwardRef as ReactComponent };